import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Box, Toolbar, Typography } from '@mui/material';

const Terms = () => {
    const { t } = useLanguage();
    return (
        <Box>
            <Toolbar>
                <div className='terms-screen'>
                    <div className='disclainerWrapper'>
                        <Typography variant='h2'>{t('terms_title')}</Typography>
                        <div className='tems-condition-content'>
                            <div className='terms-heading'>
                                <Typography variant='h4'>1.Medical Disclaimer & Limitation of Services:</Typography>
                                <Typography variant='body1'>{t('terms_text')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>2. Nature of Screening </Typography>
                                <Typography variant='body1'>{t('terms_text1')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>3. Data Privacy & Consent (DPDP Act Compliance)</Typography>
                                <Typography variant='body1'>{t('terms_text2')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>4. User Responsibilities</Typography>
                                <Typography variant='body1'>{t('terms_text3')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>5. Intellectual Property</Typography>
                                <Typography variant='body1'>{t('terms_text4')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>6. Limitation of Liability</Typography>
                                <Typography variant='body1'>{t('terms_text5')}</Typography>
                            </div>
                            <div className='terms-heading'>
                                <Typography variant='h4'>7. Grievance Redressal</Typography>
                                <Typography variant='body1'>{t('terms_text6')}</Typography>
                                <Typography variant='body1'>{t('terms_text7')}</Typography>
                            </div>

                        </div>
                    </div>
                </div>
            </Toolbar>
        </Box>
    );
};

export default Terms;